import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Box, Tab, Tabs, Typography } from '@mui/material';

const SAQUES_PATH = '/transactions/saques';
const REPASSES_PATH = '/transactions/repasses';
const ZUADARIA_PATH = '/transactions/zuadaria';

export default function TransactionsLayout() {
  const location = useLocation();
  const section = location.pathname.includes('/zuadaria')
    ? 'zuadaria'
    : location.pathname.includes('/repasses')
      ? 'repasses'
      : 'saques';

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          mb: 1,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h5" fontWeight={700} sx={{ lineHeight: 1.2 }}>
            Transações
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {section === 'zuadaria'
              ? 'Repasses dos shows da Zuadaria, fora do repasse geral.'
              : section === 'repasses'
                ? 'Visão contábil de repasses por evento e paróquia, sem a Zuadaria.'
                : 'Solicitações de saque, repasses manuais e controle operacional.'}
          </Typography>
        </Box>
      </Box>

      <Tabs
        value={section}
        sx={{ borderBottom: 1, borderColor: 'divider', minHeight: 40, mb: 1.5 }}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab
          label="Saques"
          value="saques"
          component={NavLink}
          to={SAQUES_PATH}
          sx={{ textTransform: 'none', fontWeight: 600, minHeight: 40, py: 0 }}
        />
        <Tab
          label="Repasses"
          value="repasses"
          component={NavLink}
          to={REPASSES_PATH}
          sx={{ textTransform: 'none', fontWeight: 600, minHeight: 40, py: 0 }}
        />
        <Tab
          label="Zuadaria"
          value="zuadaria"
          component={NavLink}
          to={ZUADARIA_PATH}
          sx={{ textTransform: 'none', fontWeight: 600, minHeight: 40, py: 0 }}
        />
      </Tabs>

      <Outlet />
    </Box>
  );
}
